// @flow
import type AppState from 'advertisers/redux/types/AppState';

export const getToken = (state: AppState) => state.session.token;
export const getUser = (state: AppState) => state.session.user;
export const isAuthenticated = (state: AppState) => state.session.isAuthenticated;



// WEBPACK FOOTER //
// ./src/advertisers/modules/authentication/selectors/sessionSelectors.js